import { computed, readonly, ref } from 'vue'

/**
 * Lower-cased because axios normalises response header names.
 * Mirrors `App\Http\Middleware\AddAppVersionHeader::HEADER`.
 */
export const APP_VERSION_HEADER = 'x-preno-version'

const isOutdated = ref(false)

/**
 * The deploy that served the page this bundle booted from. Blade writes it into
 * `window.PnBaseData` at render time, so it is pinned to the JS currently running,
 * not to whatever is deployed now.
 */
function loadedVersion(): string | undefined {
    return window.PnBaseData?.version
}

/**
 * Compare the deploy that served an API response against the deploy that served this
 * bundle. Once they diverge, the tab is running JS from a previous release against the
 * current backend — a payload the old code expects may already be gone, which crashes it
 * (e.g. `user.mfa` being dropped from the app-data DTO). Mark the app as outdated so the
 * user can be moved onto the new bundle.
 */
export function recordServedAppVersion(servedVersion: unknown): void {
    const loaded = loadedVersion()

    if (typeof servedVersion !== 'string' || !servedVersion || !loaded) {
        return
    }

    if (servedVersion !== loaded) {
        isOutdated.value = true
    }
}

/** Non-reactive read, for callers outside a component (e.g. router guards). */
export function isAppOutdated(): boolean {
    return isOutdated.value
}

/** Full page load — the only way to pick up the newly deployed bundle. */
export function reloadApp(url: string = window.location.href): void {
    window.location.assign(url)
}

export function useAppVersion() {
    return {
        isOutdated: readonly(isOutdated),
        appVersion: computed(loadedVersion),
        reloadApp,
    }
}
